import { createAction } from '@ngrx/store';

export const loadStatusGroup = createAction('[Invoice] Load Status Group');
